/**
 * Created by Ning Jiang on 2024-01-10.
 */

import {DeadwoodRipReelController} from "./DeadwoodRipReelController";
import {DeadwoodRipSymbolState} from "../symbol/DeadwoodRipSymbolConfig";
import {DeadwoodRipSymbol} from "../symbol/DeadwoodRipSymbol";
import {DeadwoodRipStackedSymbol} from "../symbol/DeadwoodRipStackedSymbol";
import {DeadwoodRipS2Symbol} from "../symbol/DeadwoodRipS2Symbol";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";

export class DeadwoodRipLastReelController extends DeadwoodRipReelController {

    constructor() {
        super(4);
    }

    public createSymbol(symName:string, reelId:number, state:DeadwoodRipSymbolState):DeadwoodRipSymbol {
        if(symName.includes("S2")) {
            return new DeadwoodRipS2Symbol(symName, this.reelId, state);
        }
        // if(symName.includes("WXS")) {
        //     return new DeadwoodRipStackedSymbol(symName, this.reelId, state);
        // }
        // if(symName.includes("D")) {
        //     return new DeadwoodRipStackedSymbol(symName, this.reelId, state);
        // }

        return new DeadwoodRipStackedSymbol(symName, this.reelId, state);
    }

    // TODO: shall we care about init bottom num?
    protected makeUpStopReelSetRandomFillUp(length:number):string[] {
        let result:string[] = [];
        while(result.length < length) {
            const randomSymbol = ArrayHelper.getRandomValue(["M1D", "M2D", "M3D", "M4D", "M5D"]);
            result = result.concat([`${randomSymbol}*0`, `${randomSymbol}*1`]);
        }
        return result;
    }
}